import type Uppy from '@uppy/core';
import type { Meta } from '@uppy/core';

import { useUppyState } from '@uppy/react';

/**
 * Whether the uploader is mid-operation and must not be closed or edited:
 * true while a queued file is uploading (started, not finished, not failed)
 * or while `isConfirming`.
 */
export function useIsUploaderBusy(
  uppy: Uppy<Meta, Record<string, never>>,
  isConfirming: boolean,
) {
  const isUploading = useUppyState(uppy, (state) =>
    Object.values(state.files).some(
      (file) =>
        file.progress.uploadStarted != null &&
        !file.progress.uploadComplete &&
        !file.error,
    ),
  );

  return isUploading || isConfirming;
}
